import { render, staticRenderFns } from "./WhatsappIcon.vue?vue&type=template&id=519e5abe&scoped=true"
import script from "./WhatsappIcon.vue?vue&type=script&lang=js"
export * from "./WhatsappIcon.vue?vue&type=script&lang=js"
import style0 from "./WhatsappIcon.vue?vue&type=style&index=0&id=519e5abe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519e5abe",
  null
  
)

export default component.exports